import {Model} from './Model';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

interface CountryTranslation {
  id: number;
  title: string;
  language: string;
  languageParent: number;
}

export class Country extends Model implements SessionStorageObject {
  public title: string = '';
  public iso31661alpha2: string = '';
  public iso31661alpha3: string = '';
  public translations: null | { [key: string]: CountryTranslation } = null;

  constructor(data: any) {
    super(data);

    this.title = data.title;
    this.iso31661alpha2 = data.iso31661alpha2;
    this.iso31661alpha3 = data.iso31661alpha3;
    this.translations = data.translations;
  }

  fromStorage(data: any) {
    return new Country(data);
  }

  toString(): string {
    return this.title;
  }
}
